// extracted by mini-css-extract-plugin
export default {"contactUs":"ContactUs_contactUs__h1LzB","subtitle":"ContactUs_subtitle__a5YIU","link":"ContactUs_link__XxWaa","innerContainer":"ContactUs_innerContainer__5EuZX"};